export const getRandomColor = () => {
  // eslint-disable-next-line no-bitwise
  const r = () => (Math.random() * 256) >> 0
  const color = `rgb(${r()}, ${r()}, ${r()})`
  return color
}
